import { render, staticRenderFns } from "./EmojiPopup.vue?vue&type=template&id=59260a6f&scoped=true&"
import script from "./EmojiPopup.vue?vue&type=script&lang=ts&"
export * from "./EmojiPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59260a6f",
  null
  
)

export default component.exports